module.exports = __webpack_public_path__ + "img/mirage.d0c12688.jpg";